/* Theme integration with Upcart's documented subscription API and public selectors. */
(() => {
  'use strict';
  if (window.edmtCartBridge) return;
  const bridge = window.edmtCartBridge = { connected: false };
  let opened = false;
  let opener = null;
  const syncThemeCart = cart => {
    if (typeof window.theme?.StickyCart?.refresh !== 'function' || !document.getElementById('StickyCart') || !Number.isFinite(cart.total)) return;
    // Verified Upcart quantities and totals are in Shopify's native units.
    // Render directly from the app snapshot without an independent cart store.
    const count = cart.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    window.theme.StickyCart.refresh({ item_count: count, total_price: cart.total });
    if (/^[A-Z]{3}$/.test(cart.currency || '')) document.getElementById('StickySubtotal')?.setAttribute('data-edmt-currency', cart.currency);
  };
  const drawer = () => document.querySelector('.upcart-cart');
  const controls = root => [...root.querySelectorAll('a[href],button,input,select,textarea,iframe,[tabindex]')]
    .filter(e => !e.disabled && e.tabIndex >= 0 && !e.closest('[inert]') && e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden');
  const syncDrawer = () => {
    document.documentElement.toggleAttribute('data-edmt-cart-open', opened);
    const root = drawer();
    if (!root) return;
    root.inert = !opened;
    root.setAttribute('aria-hidden', String(!opened));
    if (opened) {
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-label', document.querySelector('[data-edmt-cart-label]')?.dataset.edmtCartLabel || 'Cart');
    } else {
      root.removeAttribute('aria-modal');
    }
  };
  const syncCart = cart => {
    if (!cart || !Array.isArray(cart.items)) return;
    syncThemeCart(cart);
    if (/^[A-Z]{3}$/.test(cart.currency || '')) {
      document.querySelectorAll('.upcart-public-cart-summary').forEach(e => e.setAttribute('data-edmt-currency', cart.currency));
    }
    syncDrawer();
  };
  const refresh = event => requestAnimationFrame(() => {
    syncCart(event?.cart || window.upcartGetCart());
    syncDrawer();
  });
  const connect = () => {
    if (bridge.connected || !['CartLoaded','CartUpdated','CartOpened','CartClosed'].every(name => typeof window['upcartSubscribe' + name] === 'function') || typeof window.upcartGetCart !== 'function') return;
    bridge.connected = true;
    document.removeEventListener('load', connect, true);
    window.upcartSubscribeCartLoaded(refresh);
    window.upcartSubscribeCartUpdated(refresh);
    window.upcartSubscribeAddedToCart(refresh);
    window.upcartSubscribeItemRemoved(refresh);
    window.upcartSubscribeCartOpened(() => {
      opened = true;
      const active = document.activeElement;
      if (active && !drawer()?.contains(active) && active !== document.body) opener = active;
      syncDrawer();
      requestAnimationFrame(() => {
        syncDrawer();
        const root = drawer();
        if (root && !root.contains(document.activeElement)) (controls(root)[0] || root).focus({ preventScroll: true });
        refresh();
      });
    });
    window.upcartSubscribeCartClosed(() => {
      opened = false;
      syncDrawer();
      if (opener?.isConnected && !opener.disabled && opener.getClientRects().length) opener.focus({ preventScroll: true });
      refresh();
    });
    document.addEventListener('click', event => {
      const target = event.target.closest?.('.js-drawer-open-cart,.add-to-cart,#StickyItems');
      if (target) opener = target;
      if (target?.id === 'StickyItems' && typeof window.upcartOpenCart === 'function') {
        event.preventDefault();
        window.upcartOpenCart();
      }
    }, true);
    document.addEventListener('keydown', event => {
      const root = drawer();
      if (!opened || !root || !root.contains(event.target)) return;
      if (event.key === 'Escape' && typeof window.upcartCloseCart === 'function') {
        event.preventDefault();
        window.upcartCloseCart();
      }
    }, true);
    let currentRoot = drawer();
    new MutationObserver(() => {
      const nextRoot = drawer();
      if (nextRoot === currentRoot) return;
      currentRoot = nextRoot;
      syncDrawer();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('page:loaded', refresh);
    window.addEventListener('pageshow', refresh);
    refresh();
  };
  document.addEventListener('load', connect, true);
  document.addEventListener('DOMContentLoaded', () => { connect(); if (bridge.connected) refresh(); }, { once: true });
  window.addEventListener('load', () => { connect(); if (bridge.connected) refresh(); }, { once: true });
  connect();
})();
